import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast, ToastContainer } from "react-toastify";
import { getApiOrigin } from "../../../lib/apiConfig";
import { getEmployee } from "../../../lib/getEmployee";
import { sendprofileImage } from "../../../lib/profileImage";
import { updateEmployee } from "../../../lib/updateEmployee";
// React component names must start with an uppercase letter
const EditAfiliado = () => {
    const [employeeData, setEmployeeData] = useState({});
    const [profileImage, setProfileImage] = useState('');
    const serverHost = getApiOrigin();
    useEffect(() => {
        const fetchEmployeeData = async () => {
            let userDetails = JSON.parse(localStorage.getItem('userDetailsAfiliate'));
            const employeeId = userDetails?.employee._id;
            if (employeeId) {
                try {
                    const employee = await getEmployee(employeeId);
                    setEmployeeData(employee);
                    userDetails.employee = employee
                    localStorage.setItem("userDetailsAfiliate", JSON.stringify(userDetails))
                    if(employee?.credentialData?.credentialPhoto && employee?.credentialData?.credentialPhoto!==''){
                        setProfileImage(serverHost+employee?.credentialData?.credentialPhoto ?? '');
                    }else{
                        setProfileImage('https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg');
                    }
                    
                } catch (error) {
                    console.error('Error fetching employee data', error);
                }
            }
        };

        fetchEmployeeData();
    }, []);

    // Function to handle file input change and save to backend
    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                setProfileImage(reader.result);
                try {
                    await sendprofileImage(file, employeeData);
                    notifyBottomLeft("✔️ Tu foto de afiliado fue guardada exitosamente");
                } catch (e) {
                    const imageError =  (employeeData.credentialData?.credentialPhoto && employeeData.credentialData?.credentialPhoto !=='') ? serverHost + employeeData.credentialData?.credentialPhoto :'https://icon-library.com/images/default-profile-icon/default-profile-icon-24.jpg';
                    setProfileImage(imageError);
                    console.error('Error saving profile image', e);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    // Function to handle form submission and update employee details
    const handleUpdate = async (event) => {
        event.preventDefault();
        try {
            await updateEmployee(employeeData);
            // Update local storage with new employee data
            let userDetails = JSON.parse(localStorage.getItem("userDetailsAfiliate"))
            userDetails.employee=employeeData
            localStorage.setItem('userDetailsAfiliate', JSON.stringify(userDetails));
            notifyBottomLeft("✔️ Tus datos de afiliado se editaron exitosamente")

        } catch (error) {
            console.error('Error updating employee details', error);
        }
    };

    // Function to handle Select change without reinitializing the component
    const handleSelectChange = (field, selectedOption) => {
        setEmployeeData(prevData => ({
            ...prevData,
            [field]: selectedOption.value
        }));
    };

    const notifyBottomLeft = (message) => {
        //
        toast.success(message, {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
        });
      };

    return (
        <>     
        <div className="m-4"><Link to={"/afiliado"}> &lt;&lt; Credencial </Link></div>
            <ToastContainer />
            <div className="row">
                <div className="col-xl-4 col-lg-4">
                    <div className="clearfix">
                        <div className="card card-bx profile-card author-profile m-b30">
                            <div className="card-body">
                                <div className="p-5">
                                    <div className="author-profile">
                                        <div className="author-media">
                                            <img src={profileImage}
                                                alt="Profile" />
                                            <div className="upload-link" title="" data-toggle="tooltip" data-placement="right" data-original-title="update">
                                                <input type="file" className="update-flie" onChange={handleFileChange} />
                                                <i className="fa fa-camera"></i>
                                            </div>
                                        </div>
                                        <div className="author-info">
                                            <h6 className="title">{employeeData.name?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="info-list">
                                    <ul>
                                        <li><Link to={"/#"}>Cuil</Link>    <span className="text-purple ">{employeeData.cuil || 'Sin CUIL'}</span></li>
                                        <li><Link to={"/#"}>DNI</Link><span>{employeeData.dni || 'Sin DNI'}</span></li>
                                        <li><Link to={"/#"}>Email</Link><span>{employeeData.email || ''}</span></li>
                                    </ul>
                                </div>
                                <div>
                                 
                                </div>
                                <div className="info-list">
                                    <ul>
                                        <li></li>
                                        <li><Link to={"/#"}>Empleador:</Link>    <span className="text-purple ">{employeeData.company?.name || ''}</span></li>
                                        <li><Link to={"/#"}>Email</Link><span>{employeeData.company?.email || 'Sin DNI'}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="input-group mb-3">
                                    <div className="form-control rounded text-center bg-white">Nº afiliado:   <span><b>{employeeData.credentialData?.credentialNumber || 'sin numero'}</b></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-8 col-lg-8">
                    <div className="card profile-card card-bx m-b30">
                        <div className="card-header">
                            <h6 className="title">Datos Afiliado</h6>
                        </div>
                        <form className="profile-form" onSubmit={handleUpdate}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Email</label>
                                        <input type="text" className="form-control" value={employeeData?.email || ''} onChange={(e) => setEmployeeData({ ...employeeData, email: e.target.value })} />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">DNI</label>
                                        <input type="text"  className="form-control" value={employeeData?.dni || ''} onChange={(e) => setEmployeeData({ ...employeeData, dni: e.target.value })} />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Telefono</label>
                                        <input type="text" className="form-control" value={employeeData?.phoneNumber || ''} onChange={(e) => setEmployeeData({ ...employeeData, phoneNumber: e.target.value })} />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Sexo</label>
                                        <Select 
                                            className="custom-react-select"
                                            options={[
                                                { value: 'Masculino', label: 'Masculino' },
                                                { value: 'Femenino', label: 'Femenino' },
                                            ]}
                                            value={employeeData?.sexo ? { value: employeeData.sexo, label: employeeData.sexo } : null}
                                            onChange={(selectedOption) => handleSelectChange('sexo', selectedOption)}
                                            isSearchable={true}
                                        />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Estado Civil</label>
                                        <input type="text" className="form-control" value={employeeData?.estadoCivil || ''} onChange={(e) => setEmployeeData({ ...employeeData, estadoCivil: e.target.value })} />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Domicilio</label>
                                        <input type="text" className="form-control" value={employeeData?.domicilio || ''} onChange={(e) => setEmployeeData({ ...employeeData, domicilio: e.target.value })} />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Ciudad</label>
                                        <input type="text" className="form-control" value={employeeData?.ciudad || ''} onChange={(e) => setEmployeeData({ ...employeeData, ciudad: e.target.value })} />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Provincia</label>
                                        {/* Dropdown for selecting Argentine provinces */}
                                        <Select 
                                            className="custom-react-select"
                                            options={[
                                                { value: 'Buenos Aires', label: 'Buenos Aires' },
                                                { value: 'Córdoba', label: 'Córdoba' },
                                                { value: 'Santa Fe', label: 'Santa Fe' },
                                                { value: 'Mendoza', label: 'Mendoza' },
                                                { value: 'Tucumán', label: 'Tucumán' },
                                                { value: 'Salta', label: 'Salta' },
                                                { value: 'Entre Ríos', label: 'Entre Ríos' },
                                                { value: 'Misiones', label: 'Misiones' },
                                                { value: 'Chaco', label: 'Chaco' },
                                                { value: 'Corrientes', label: 'Corrientes' },
                                                { value: 'Santiago del Estero', label: 'Santiago del Estero' },
                                                { value: 'San Juan', label: 'San Juan' },
                                                { value: 'Jujuy', label: 'Jujuy' },
                                                { value: 'Río Negro', label: 'Río Negro' },
                                                { value: 'Neuquén', label: 'Neuquén' },
                                                { value: 'Formosa', label: 'Formosa' },
                                                { value: 'Chubut', label: 'Chubut' },
                                                { value: 'San Luis', label: 'San Luis' },
                                                { value: 'Catamarca', label: 'Catamarca' },
                                                { value: 'La Rioja', label: 'La Rioja' },
                                                { value: 'La Pampa', label: 'La Pampa' },
                                                { value: 'Santa Cruz', label: 'Santa Cruz' },
                                                { value: 'Tierra del Fuego', label: 'Tierra del Fuego' }
                                            ]}
                                            value={employeeData?.provincia ? { value: employeeData.provincia, label: employeeData.provincia } : null}
                                            onChange={(selectedOption) => handleSelectChange('provincia', selectedOption)}
                                            isSearchable={true}
                                        />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">País</label>
                                        <Select 
                                            className="custom-react-select"
                                            options={[
                                                { value: 'Argentina', label: 'Argentina' },
                                                { value: 'Bolivia', label: 'Bolivia' },
                                                { value: 'Brasil', label: 'Brasil' },
                                                { value: 'Chile', label: 'Chile' },
                                                { value: 'Colombia', label: 'Colombia' },
                                                { value: 'Ecuador', label: 'Ecuador' },
                                                { value: 'Paraguay', label: 'Paraguay' },
                                                { value: 'Perú', label: 'Perú' },
                                                { value: 'Surinam', label: 'Surinam' },
                                                { value: 'Uruguay', label: 'Uruguay' },
                                                { value: 'Venezuela', label: 'Venezuela' }
                                            ]}
                                            value={employeeData?.pais ? { value: employeeData.pais, label: employeeData.pais } : null}
                                            onChange={(selectedOption) => handleSelectChange('pais', selectedOption)}
                                            isSearchable={true}
                                        />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Tipo Trabajo</label>
                                        <Select 
                                            className="custom-react-select"
                                            options={[
                                                { value: 'Remoto', label: 'Remoto' },
                                                { value: 'OnSite', label: 'OnSite' },
                                            ]}
                                            value={employeeData?.tipo_trabajo ? { value: employeeData.tipo_trabajo, label: employeeData.tipo_trabajo } : null}
                                            onChange={(selectedOption) => handleSelectChange('tipo_trabajo', selectedOption)}
                                            isSearchable={true}
                                        />
                                    </div>
                                    <div className="col-sm-6 m-b30">
                                        <label className="form-label">Area Trabajo</label>
                                        <input type="text" className="form-control" value={employeeData?.area_trabajo || ''} onChange={(e) => setEmployeeData({ ...employeeData, area_trabajo: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary">Guardar Datos </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
export default EditAfiliado;
